import { createMMKV } from 'react-native-mmkv';

export const storage = createMMKV({ id: 'analytics-session' });

const KEYS = {
  LAST_ACTIVE_AT: 'lastActiveAt',
  SESSION_ID: 'sessionId',
} as const;

export const SessionStorage = {
  getLastActiveAt: () => storage.getNumber(KEYS.LAST_ACTIVE_AT),
  getSessionId: () => storage.getString(KEYS.SESSION_ID),
  setLastActiveAt: (ts: number) => {
    storage.set(KEYS.LAST_ACTIVE_AT, ts);
  },
  setSessionId: (id: string) => {
    storage.set(KEYS.SESSION_ID, id);
  },
};
